import fullscreenTemplate from './custom-fullscreen/fullscreen-template.twig';
import zoomTemplate from './custom-zoom/zoom-template.twig';

class Controls {
    init(map, settings, ymaps) {
        this.map = map;
        this.settings = settings;
        this.ymaps = ymaps;

        this._initZoom();
        this._initScrollZoom();
        this._addFullScreenControl();

        if (settings.disableMobileDrag) {
            this._disableMobileDrag();
        }
    }

    /**
     * Добавляет зум на карту.
     * @private
     */
    _initZoom() {
        if (!this.settings.zoomControl) {
            return;
        }

        if (this.settings.customZoomControl) {
            this._initCustomZoomControl();
        } else {
            this.map.controls.add(`zoomControl`);
        }
    }

    /**
     * Разрешает или запрещает сколл страницы при фокусе на карте.
     * @private
     */
    _initScrollZoom() {
        const scrollZoom = this.settings.zoomScroll;

        if (scrollZoom) {
            this.map.behaviors.enable('scrollZoom');
        } else {
            this.map.behaviors.disable('scrollZoom');
        }
    }

    /**
     * Добавляет кнопку открытия карты на полный экран
     */
    _addFullScreenControl() {
        if (!this.settings.fullScreenControl) {
            return;
        }

        if (this.settings.customFullScreenControl) {
            this._initCustomFullscreenControl();
        } else {
            this.map.controls.add('fullscreenControl');
        }
    }

    /**
     * Отключаем перетаскивание карты при прокрутке одним пальцем на мобилке
     */
    /* eslint-disable */
    _disableMobileDrag() {
        const isMobile = {
            Android: () => {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: () => {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: () => {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: () => {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: () => {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: () => {
                return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
            }
        };

        if (isMobile.any()) {
            this.map.behaviors.disable('drag');
        }
    }
    /* eslint-enable */

    /**
     * Инициализация кастомных контролов
     */
    _initCustomZoomControl() {
        const ymaps = this.ymaps;
        const mapId = this.map.container._parentElement.id;

        const ZoomLayout = ymaps.templateLayoutFactory.createClass(zoomTemplate({mapId}), {

            // Переопределяем методы макета, чтобы выполнять дополнительные действия
            // при построении и очистке макета.
            build() {
                // Вызываем родительский метод build.
                ZoomLayout.superclass.build.call(this);

                // Привязываем функции-обработчики к контексту и сохраняем ссылки
                // на них, чтобы потом отписаться от событий.
                this.zoomInCallback = ymaps.util.bind(this.zoomIn, this);
                this.zoomOutCallback = ymaps.util.bind(this.zoomOut, this);

                // Начинаем слушать клики на кнопках макета.
                $(`#${mapId}-zoom-in`).bind('click', this.zoomInCallback);
                $(`#${mapId}-zoom-out`).bind('click', this.zoomOutCallback);
            },

            clear() {
                // Снимаем обработчики кликов.
                $(`#${mapId}-zoom-in`).unbind('click', this.zoomInCallback);
                $(`#${mapId}-zoom-out`).unbind('click', this.zoomOutCallback);

                // Вызываем родительский метод clear.
                ZoomLayout.superclass.clear.call(this);
            },

            zoomIn() {
                const map = this.getData().control.getMap();

                map.setZoom(map.getZoom() + 1, {
                    checkZoomRange: true
                });
            },

            zoomOut() {
                const map = this.getData().control.getMap();

                map.setZoom(map.getZoom() - 1, {
                    checkZoomRange: true
                });
            }
        });

        const zoomControl = new ymaps.control.ZoomControl({
            options: {
                layout  : ZoomLayout,
                position: {
                    bottom: 0,
                    right : 20
                }
            }
        });


        this.map.controls.add(zoomControl);
    }

    _initCustomFullscreenControl() {
        const ymaps = this.ymaps;

        const FullscreenLayout = ymaps.templateLayoutFactory.createClass(fullscreenTemplate());

        const fullscreenControl = new ymaps.control.FullscreenControl({
            options: {
                layout  : FullscreenLayout,
                position: {
                    top  : null,
                    right: 0
                }
            }
        });

        this.map.controls.add(fullscreenControl);
    }
}

export default Controls;
